import { render, staticRenderFns } from "./VeJwSkjhmxList.vue?vue&type=template&id=6923ed11&scoped=true"
import script from "./VeJwSkjhmxList.vue?vue&type=script&lang=js"
export * from "./VeJwSkjhmxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6923ed11",
  null
  
)

export default component.exports